<template>
  <div class="m-0 dbozone-font bg-grandshine" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-grandshine">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('1_3_base.paytable.title') }}</h5>
        </section>
      </div>

      <div class="mt-4 table-bg-grandshine" >
        <div class="table-detail" v-for="(text, index) in price" :key="index">
          <div class = "text-price-box">
              <p class="payprice" :class="`-${lang}`">{{`x${text}`}} </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-grandshine mt-5">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('1_3_base.paytable.symtable_wild') }}</h5>
        </section>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-3 icon-paytable-onerow" :src="require(`../../assets/paytable/grandshine/wild.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('grand_shine.text-rule13') }}</span>
      </div>
    </div>

    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-grandshine">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('1_3_base.winbetline') }}</h5>
        </section>
      </div>
      <div class="d-flex p-1 mb-1 mt-3">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('1_3_base.text-rule15') }}</span>
      </div>
      <div class="d-flex p-1 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('1_3_base.text-rule11') }}</span>
      </div>
      <div class="d-flex p-1 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('1_3_base.text-rule12') }}</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'paytable-grandshine',
  props: {
    data: Object,
    lang: String,
  },
    data() {
    return {
        paytable: this.data.config.payTable,
        price: {}
      }
    },
    created() {
      this.sortPrice()
    },

    methods : {
        sortPrice(){
            let priceList = [];
            for(let key in this.data.config.payTable){
              priceList.push(this.data.config.payTable[key])
            }
            let uniqe =  priceList.filter((v, i, a) => a.indexOf(v) === i).sort((a,b) => b - a )
            this.price = uniqe;
        }
    }
}
</script>

<style>

.table-bg-grandshine {
  background: url('~@/assets/paytable/grandshine/paytable.png') no-repeat;
  background-size: 690px 1100px;
  width: 690px;
  height: 1100px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

</style>